/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.FAQResponse, () => void, () => void];

function useFetchFAQs({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.FAQResponse>({
    ErrorMessage: '',
    Success: false,
    FAQCategories: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchFAQs(source);
      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);
      return () => {};
    };
    if (shouldSendRequest) void sendRequest();
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);
  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setResponse({
        ErrorMessage: '',
        Success: false,
        FAQCategories: {},
      });
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchFAQs);
